import React, { useState } from "react";
import { Box, Container, Tabs, Tab, Typography } from "@mui/material";
import ProfileForm from "../components/forms/ProfileForm"; 
import {
    AccountCircle,
    Business,
    MonetizationOn,
    Lock,
    Notifications,
    Campaign,
    Savings,
  } from "@mui/icons-material"; 
import EntrepreneurForm from "../components/forms/EntrepreneurForm"; 
import InvestorForm from "../components/forms/InvestorForm"; 
import SecurityAndAccess from "../components/forms/SecurityAndAccess"; 
import SecurityAndPrivacy from "../components/forms/SecurityAndPrivacy"; 
import MyCampaigns from "../../src/components/forms/MyCampainsForm";
import InvestmentForm from "../components/forms/InvestmentForm";
import { useTheme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import { ProfileProvider, useProfile } from '../context/ProfileContext';

const ProfilePageWrapper = () => {
  return (
    <ProfileProvider>
      <ProfilePage />
    </ProfileProvider>
  );
};

const ProfilePage = () => {
  const theme = useTheme();
  const { selectedTab, setSelectedTab } = useProfile();

  // URL'den hash'i kontrol et ve başlangıç tab'ini ayarla
  React.useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    const tabNames = ['profile', 'entrepreneur', 'investor', 'security', 'privacy', 'campaigns', 'investments'];
    const tabIndex = tabNames.indexOf(hash);
    if (tabIndex !== -1) {
      setSelectedTab(tabIndex);
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    // Tab değiştiğinde URL hash'ini güncelle
    const tabNames = ['profile', 'entrepreneur', 'investor', 'security', 'privacy', 'campaigns', 'investments'];
    window.location.hash = tabNames[newValue];
  };

  const menuItems = [
    { label: "Profilim", icon: <AccountCircle />, value: 0 },
    { label: "Girişimci Kayıt Formu", icon: <Business />, value: 1 },
    { label: "Yatırımcı Kayıt Formu", icon: <MonetizationOn />, value: 2 },
    { label: "Güvenlik & Girişler", icon: <Lock />, value: 3 },
    { label: "Gizlilik & Bildirimler", icon: <Notifications />, value: 4 },
    { label: "Kampanyalarım", icon: <Campaign />, value: 5 },
    { label: "Yatırım Hesabım", icon: <Savings />, value: 6 },
  ];

  return (
    <Container sx={{ paddingY: 6 }}>
      <Box sx={{ 
        display: "flex", 
        flexDirection: { xs: "column", sm: "row" }, 
        gap: 3,
      }}>
        <Box sx={{ 
          width: { xs: "100%", sm: "25%" },
          bgcolor: 'transparent',
          borderRadius: 2,
          border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
        }}>
          <Tabs
            orientation={window.innerWidth >= 600 ? "vertical" : "horizontal"}
            value={selectedTab}
            onChange={handleTabChange}
            sx={{
              minHeight: 400,
              borderRadius: 2,
              '& .MuiTabs-indicator': {
                backgroundColor: 'transparent',
              },
              '& .MuiTabs-flexContainer': {
                gap: 1,
                padding: 2,
              },
              '& .MuiTab-root': {
                minHeight: 48,
                borderRadius: 1.5,
                textAlign: "left",
                justifyContent: "flex-start",
                alignItems: "center",
                fontWeight: 500,
                fontSize: "0.875rem",
                textTransform: "capitalize",
                paddingLeft: 2,
                paddingRight: 2,
                color: theme.palette.mode === 'light' 
                  ? theme.palette.grey[600] 
                  : theme.palette.grey[400],
                '&:hover': {
                  bgcolor: theme.palette.mode === 'light'
                    ? alpha(theme.palette.primary.main, 0.08)
                    : alpha(theme.palette.primary.main, 0.15),
                  color: theme.palette.primary.main,
                },
                '&.Mui-selected': {
                  bgcolor: theme.palette.mode === 'light'
                    ? alpha(theme.palette.primary.main, 0.12)
                    : alpha(theme.palette.primary.main, 0.2),
                  color: theme.palette.primary.main,
                  fontWeight: 600,
                  paddingLeft: 2.5,
                  paddingRight: 2.5,
                  '&:hover': {
                    bgcolor: theme.palette.mode === 'light'
                      ? alpha(theme.palette.primary.main, 0.18)
                      : alpha(theme.palette.primary.main, 0.25),
                  },
                },
                transition: theme.transitions.create(['background-color', 'color', 'padding'], {
                  duration: theme.transitions.duration.shorter,
                }),
              },
            }}
          >
            {menuItems.map((item) => (
              <Tab
                key={item.value}
                icon={
                  <Box sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    marginRight: 1.5,
                    '& svg': {
                      fontSize: 20,
                    },
                  }}>
                    {item.icon}
                  </Box>
                }
                iconPosition="start"
                sx={{marginBottom: 2}}
                label={item.label}
              />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ 
          width: { xs: "100%", sm: "75%" },
          bgcolor: 'transparent',
        }}>
          <Typography 
            variant="h4" 
            gutterBottom 
            sx={{ 
              textTransform: "capitalize", 
              fontSize: "1.5rem",
              color: theme.palette.mode === 'light' 
                ? theme.palette.grey[800] 
                : theme.palette.grey[100],
              fontWeight: 600,
              mb: 3,
            }}
          >
            { /* menuItems.find((item) => item.value === selectedTab)?.label */}
          </Typography>
          <Box
            sx={{
              padding: 3,
              bgcolor: 'transparent',
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
              boxShadow: theme.customShadows.card,
            }}
          >
            {selectedTab === 0 && <ProfileForm />}
            {selectedTab === 1 && <EntrepreneurForm />}
            {selectedTab === 2 && <InvestorForm />}
            {selectedTab === 3 && <SecurityAndAccess />}
            {selectedTab === 4 && <SecurityAndPrivacy />}
            {selectedTab === 5 && <MyCampaigns />}
            {selectedTab === 6 && <InvestmentForm />}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ProfilePageWrapper;
